import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import * as Icons from '@images';

type IconType = keyof typeof Icons;

export const iconTypes: IconType[] = Object.keys(Icons) as any[];

export interface IconProps {
  icon: IconType;
  className?: string;
  style?: React.CSSProperties;
}

export const Icon = ({ icon, className, style, ...rest }: IconProps) => {
  const SVGIcon = Icons[icon];

  const StyledIcon = styled(SVGIcon)`
    ${({ theme }) =>
      css`
        g,
        path,
      `}
  `;

  return <StyledIcon className={className} style={{ verticalAlign: 'text-top', ...style }} />;
};

export default Icon;
